import { render, staticRenderFns } from "./Uniforms.vue?vue&type=template&id=353ecba2"
import script from "./Uniforms.vue?vue&type=script&lang=js"
export * from "./Uniforms.vue?vue&type=script&lang=js"
import style0 from "./Uniforms.vue?vue&type=style&index=0&id=353ecba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports